export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15137.b6ea361f.jpg";